import React, { FC } from 'react';
import { SvgIcon, SvgIconProps } from '../svg-icon';

export const LoaderIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 100 100" fill="currentColor" stroke="none" {...props}>
    <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50" />
  </SvgIcon>
);
